import React from 'react';

import {
  ELocationSearchAutocompleteListVariant,
  LocationSearchAutocompleteList,
} from '@/components/common/LocationSearchAutocompleteList/LocationSearchAutocompleteList';
import { calculateOptionIndex, IGroupOption, IOption } from '@/utility/autoCompleteGroupedOptions';

interface ILocationSearchContentProps {
  open: boolean;
  groupOptions: IGroupOption[];
  allGroupOptions: IGroupOption[];
  getListboxProps: () => Record<string, unknown>;
  getOptionProps: ({
    option,
    index,
  }: {
    option: IOption;
    index: number;
  }) => Record<string, unknown>;
}

const LocationSearchContent: React.FC<ILocationSearchContentProps> = ({
  open,
  groupOptions,
  allGroupOptions,
  getListboxProps,
  getOptionProps,
}) => {
  return (
    <div className={`w-[23rem] h-fit ${open ? 'block' : 'hidden'}`} {...getListboxProps()}>
      <LocationSearchAutocompleteList
        groupedOptions={groupOptions}
        getOptionProps={({ option, index }) =>
          getOptionProps({
            option,
            index: calculateOptionIndex(option.groupName, index, allGroupOptions),
          })
        }
        variant={ELocationSearchAutocompleteListVariant.Vertical}
        className="!pt-0"
      />
    </div>
  );
};

export default LocationSearchContent;
